<div class="overlay">
  <div class="overlay-container">
    <div class="overlay-header flex flex-row justify-between items-start">
      <div
        class="flex flex-row flex-wrap lt-md:flex-col gap-[12px] justify-start items-center lt-md:items-start"
      >
        <h1>{{ '+INSTALLATIONS.PARTNER_ACCESS.OVERLAY.TITLE' | translate }}</h1>
      </div>
      <button
        data-at-close-overlay-btn
        mat-stroked-button
        (click)="close()"
        class="close-btn-overlay lt-md:!hidden"
        gtm="onClose"
        gtmAction="Installation details overlay"
        gtmCategory="installationDetails"
      >
        <span>{{ '+INSTALLATIONS.INSTALLATION.OVERLAY.CLOSE_BUTTON' | translate }}</span>
        <mat-icon iconPositionEnd>close</mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="close()"
        class="close-btn-small !hidden lt-md:!inline-flex"
        gtm="onClose"
        gtmAction="Installation details overlay"
        gtmCategory="installationDetails"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <ng-container [ngSwitch]="activePartnerAccessOverlay">
      <app-partner-access-settings-overlay
        *ngSwitchCase="partnerAccessOverlayTypeEnum.Settings"
      ></app-partner-access-settings-overlay>
    </ng-container>
  </div>
</div>
